/**
 * Custom Interactions
 * Global event handlers for unified UI behavior
 *
 * This file provides:
 * - Global ESC key handler for closing Search, Theme Drawers, Nosto Sort/Filter
 * - PageOverlay click handler for closing all open elements
 */

(function() {
  'use strict';

  /**
   * Unified Close Handler
   * Closes all open drawers, search, and overlays
   * Used by both ESC key and PageOverlay click
   */
  function closeAllOpenElements() {
    var handled = false;

    // Close Search if open
    if (document.body.classList.contains('has-search-open')) {
      var closeSearchBtn = document.querySelector('[data-action="close-search"]');
      if (closeSearchBtn) {
        closeSearchBtn.click();
        handled = true;
      }
    }

    // Close Theme Drawers (Cart, Sidebar Menu) if open
    document.querySelectorAll('.Drawer[aria-hidden="false"]').forEach(function(drawer) {
      var closeBtn = drawer.querySelector('.Drawer__Close');
      if (closeBtn) {
        closeBtn.click();
        handled = true;
      }
    });

    // Clean up overlay body classes (in case they weren't removed by callback)
    document.body.classList.remove('has-overlay-open');
    document.body.classList.remove('has-drawer-open');

    // Close QuickAddPopover if open
    if (document.body.classList.contains('has-quick-add-open')) {
      var quickAddClose = document.querySelector('.QuickAddPopover__Close');
      if (quickAddClose) {
        quickAddClose.click();
        handled = true;
      }
    }

    // Close Nosto Sort drawer if open
    var sortMenu = document.querySelector('.ns-sort-menu-active');
    if (sortMenu) {
      sortMenu.classList.remove('ns-sort-menu-active');
      document.body.classList.remove('has-sort-drawer-open');
      handled = true;
    }

    // Close Nosto Filter sidebar if open
    var sidebar = document.querySelector('.ns-sidebar-container.ns-active-sidebar');
    if (sidebar) {
      sidebar.classList.remove('ns-active-sidebar');
      document.documentElement.classList.remove('no-scroll');
      handled = true;
    }

    // Clean up PageOverlay if any drawer was closed
    if (handled) {
      var overlay = document.querySelector('.PageOverlay');
      if (overlay) {
        overlay.classList.remove('is-visible', 'ns-overlay-active');
      }
    }

    return handled;
  }

  /**
   * Global ESC Key Handler
   */
  function initEscapeKeyHandler() {
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        closeAllOpenElements();
      }
    });
  }

  /**
   * PageOverlay Click Handler
   * Closes all elements when clicking on the overlay
   */
  function initOverlayClickHandler() {
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('PageOverlay') && event.target.classList.contains('is-visible')) {
        closeAllOpenElements();
      }
    });
  }

  // Initialize on DOM ready
  function init() {
    initEscapeKeyHandler();
    initOverlayClickHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
